/* global  */ // tUrl等のグローバル変数を宣言する

// import 'core-js/features/number/is-nan' // SwiperのIE対応
// import 'custom-event-polyfill' // SwiperのIE対応
// import 'slick-carousel'
import isBrowser from './functions/_isBrowser.js' // UserAgentをブラウザ名で返す

import scrollLock from './functions/_scrollLock.js'
import { gsap, ScrollTrigger, Draggable, MotionPathPlugin } from 'gsap/all'
import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

//
//    ###    ##     ##  ##  ###    ###  #####
//   ## ##   ####   ##  ##  ## #  # ##  ##
//  ##   ##  ##  ## ##  ##  ##  ##  ##  #####
//  #######  ##    ###  ##  ##      ##  ##
//  ##   ##  ##     ##  ##  ##      ##  #####
//
$(function () {
  if (document.getElementsByClassName('js-in')[0]) {
    // 画面に入った監視対象に.animatedを付加
    // Intersection Observer
    intObs()
  }
  function intObs() {
    let rootMargin = '-10px 0px'
    if (window.matchMedia('(max-width:768px)').matches) {
      //SPは検出を早くする
      rootMargin = '100px 0px'
    }
    const intObsOption = {
      // root: document.querySelector('#obsArea'), // 監視領域 省略でビューポート
      rootMargin: rootMargin, // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
      threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
    }
    const observer = new IntersectionObserver(intObsCallback, intObsOption)
    const intObsItems = document.getElementsByClassName('js-in')
    for (let index = 0; index < intObsItems.length; index++) {
      const intObsItem = intObsItems[index]
      observer.observe(intObsItem) // 監視対象に加える
    }
    function intObsCallback(entries) {
      for (let index = 0; index < entries.length; index++) {
        const entry = entries[index]
        if (entry.isIntersecting) {
          const entryItem = entry.target
          entryItem.classList.add('active')
          observer.unobserve(entryItem) // 監視対象から外す
        }
      }
    }
  }
})

//
//  ##       #####     ###    ####    ##  ##     ##   ####
//  ##      ##   ##   ## ##   ##  ##  ##  ####   ##  ##
//  ##      ##   ##  ##   ##  ##  ##  ##  ##  ## ##  ##  ###
//  ##      ##   ##  #######  ##  ##  ##  ##    ###  ##   ##
//  ######   #####   ##   ##  ####    ##  ##     ##   ####
//
const loadingWrap = document.querySelector('.js-loading') //←動かしたい要素を指定しています。
const loadingBg = document.querySelector('.js-loading-bg') //←動かしたい要素を指定しています。
const text = document.querySelector('.js-loading-text') //←動かしたい要素を指定しています。
const logo1 = document.querySelector('.js-loading-logo-1') //←動かしたい要素を指定しています。
const logo2 = document.querySelector('.js-loading-logo-2') //←動かしたい要素を指定しています。
const logo3 = document.querySelector('.js-loading-logo-3') //←動かしたい要素を指定しています。
const logoMain = document.querySelector('.js-loading-logo-main') //←動かしたい要素を指定しています。
const logoSub = document.querySelector('.js-loading-logo-sub') //←動かしたい要素を指定しています。
const logoCopy = document.querySelector('.js-loading-copy') //←動かしたい要素を指定しています。
const content = document.querySelector('.main-content') //←動かしたい要素を指定しています。

let loadingDone = false

if (sessionStorage.getItem('init')) {
  loadingDone = true
}

const loading = gsap.timeline()
const loadingSkip = gsap.timeline()
if (!sessionStorage.getItem('init')) {
  loading
    .to(loadingWrap, { opacity: 1, delay: 0, duration: 0.8 })
    .to(text, { opacity: 1, y: '-50%', delay: 0.5, duration: 0.8 })
    .to(text, { opacity: 0, delay: 2.5, duration: 0.5 })
    .to(loadingBg, { opacity: 0.6, delay: 0, duration: 0.5 }, '<')
    .to(logo1, { opacity: 1, delay: 0, duration: 0.8 })
    .to(logo2, { opacity: 1, delay: 0, duration: 0.8 }, '<')
    .to(logo3, { opacity: 1, delay: 0, duration: 0.8 }, '<')
    .to(logo1, { y: '70%', delay: 0, duration: 1, opacity: 0 })
    .to(logo2, { y: '-70%', x: '55%', delay: 0, duration: 0.8, opacity: 0 }, '<')
    .to(logo3, { y: '-70%', x: '-55%', delay: 0, duration: 0.8, opacity: 0 }, '<')
    .to(logoMain, { opacity: 1, delay: 0.8, duration: 0.5 })
    .to(logoSub, { opacity: 1, delay: 0.5, duration: 0.5 })
    .add(() => {
      logoCopy.classList.add('active')
    }, '+=0.5')
    .to(loadingWrap, { opacity: 0, delay: 7, duration: 1 })
    .to(content, { opacity: 1, delay: 0, duration: 0 }, '-=0.5')
    .add(() => {
      loadingWrap.classList.add('hide')
    })
  sessionStorage.setItem('init', 'on')
} else {
  loading
    .add(() => {
      loadingWrap.classList.add('hide')
    })
    .to(content, { opacity: 1, delay: 0, duration: 0 }, '<')
}
$('.js-loading-skip').click(function () {
  loadingSkip
    .to(loadingWrap, { opacity: 0, delay: 0, duration: 0.5 })
    .to(content, { opacity: 1, delay: 0, duration: 0.5 }, '<')
    .add(() => {
      loadingWrap.classList.add('hide')
    })
})

//
//  ######   #####   #####    ####  ##      ##  ####    #####
//    ##    ##   ##  ##  ##  ##     ##      ##  ##  ##  ##
//    ##    ##   ##  #####    ###   ##      ##  ##  ##  #####
//    ##    ##   ##  ##         ##  ##      ##  ##  ##  ##
//    ##     #####   ##      ####   ######  ##  ####    #####
//

// console.log(loadingDone)
$(function () {
  var topMvSlide = new Swiper('#topMvSlide', {
    effect: 'fade',
    loop: true, // 無限ループさせる
    loopAdditionalSlides: 5,
    slidesPerView: 1,
    preventClicks: true,
    preventClicksPropagation: true,
    on: {
      init: function () {
        // 開始時処理
        let currentSlide = $('.swiper-slide-active')
        if (currentSlide.find('video').length) {
          let video = currentSlide.find('video').get(0)
          video.pause()
          if (loadingDone) {
            video.play()
          } else {
            video.pause()
            setTimeout(function () {
              video.play()
            }, 17000)
          }
          $('.js-loading-skip').click(function () {
            video.play()
          })
        }
      },
      slideChange: function () {},
      slideChangeTransitionStart: function () {
        let currentSlide = $('.swiper-slide-active')
        if (currentSlide.find('video').length) {
          let video = currentSlide.find('video').get(0)
          video.play()
          video.addEventListener('ended', (event) => {
            topMvSlide.slideNext()
          })
        } else {
          setTimeout(function () {
            topMvSlide.slideNext()
          }, 3000)
        }
      },
      slideChangeTransitionEnd: function () {
        // 任意の処理を実行
      },
      imagesReady: function () {
        // 任意の処理を実行
      },
    },
  })
})

/*
######   ######  ########   #######  ##       ##
##    ## ##    ## ##     ## ##     ## ##       ##
##       ##       ##     ## ##     ## ##       ##
#######  ######  ##       ########  ##     ## ##       ##
      ## ##       ##   ##   ##     ## ##       ##
##    ## ##    ## ##    ##  ##     ## ##       ##
 ######   ######  ##     ##  #######  ######## ########
*/

// stickyの代替処理
if (document.getElementById('js-fixArea')) {
  fixArea()
}
function fixArea() {
  let isAction = false // 処理フラグ
  let scrollY = window.pageYOffset // 縦方向のスクロール量
  const frame = document.getElementById('js-fixArea') // フレーム
  const item = document.getElementById('js-fixArea-item') // スクロールさせるアイテム
  const adjust = document.getElementById('header').offsetHeight * 1.5 // ヘッダー要素の調整
  let state = 'stay'
  document.addEventListener(
    'scroll',
    function () {
      scrollY = window.pageYOffset // スクロール量更新
      fixAreaApply()
    },
    { passive: true }
  )
  fixAreaApply()
  function fixAreaApply() {
    if (!isAction) {
      // レンダリング準備が整ったら開始
      requestAnimationFrame(function () {
        isAction = false
        const frameHeight = frame.offsetHeight
        const frameTop = frame.getBoundingClientRect().top + scrollY
        const frameBottom = frameTop + frameHeight
        const itemHeight = item.offsetHeight
        const itemTop = item.getBoundingClientRect().top + scrollY
        const itemBottom = itemTop + itemHeight
        // フレームがアイテムより高くなければ終了
        if (frameHeight <= itemHeight) {
          isAction = false // フラグをOFFに戻す
          return
        }

        if (state === 'stay') {
          // スクロールがアイテムのTOPを追い越したら追従
          if (scrollY + adjust >= itemTop) {
            item.classList.add('move')
            state = 'move'
          }
        } else if (state === 'move') {
          if (itemTop <= frameTop) {
            item.classList.remove('move')
            state = 'stay'
          } else if (itemBottom >= frameBottom) {
            item.classList.remove('move')
            item.classList.add('end')
            state = 'end'
          }
        } else {
          if (item.getBoundingClientRect().top > adjust) {
            item.classList.remove('end')
            item.classList.add('move')
            state = 'move'
          }
        }
      })
      isAction = true
    }
  }
}

/*
             ###     ######  ######## #### ##     ## ########
            ## ##   ##    ##    ##     ##  ##     ## ##
           ##   ##  ##          ##     ##  ##     ## ##
  ####### ##     ## ##          ##     ##  ##     ## ######
          ######### ##          ##     ##   ##   ##  ##
          ##     ## ##    ##    ##     ##    ## ##   ##
          ##     ##  ######     ##    ####    ###    ########
  */
// 走査線に入っているアイテムをアクティブにする
if (document.getElementsByClassName('js-scrollNav')[0]) {
  scrollNav()
}
function scrollNav() {
  // スクロールナビゲーション
  let isAction = false // 処理フラグ
  let scrollY = window.pageYOffset // 縦方向のスクロール量
  const items = document.getElementsByClassName('js-scrollNav') // 処理対象
  const triggers = document.getElementsByClassName('js-scrollNav-trigger') // 判定対象
  const sensor = document.getElementById('js-scrollNav-sensor') // 走査線要素 ID指定
  document.addEventListener(
    'scroll',
    function (ev) {
      // スクロール量の更新だけを行う
      scrollY = window.pageYOffset // スクロール量更新
      scrollNavApply()
    },
    { passive: true }
  )
  scrollNavApply()
  function scrollNavApply() {
    if (window.matchMedia('(max-width:768px)').matches) {
      // SPはスキップ
      return
    }
    if (!isAction) {
      // レンダリング準備が整ったら開始
      requestAnimationFrame(function () {
        isAction = false
        for (let index = 0; index < triggers.length; index++) {
          const trigger = triggers[index]
          const triggerStart = trigger.getBoundingClientRect().top + scrollY // 画面上部からのターゲットの位置
          const triggerEnd = triggerStart + trigger.offsetHeight // 画面下部からのターゲットの位置
          const sensorVal = sensor.getBoundingClientRect().top + window.pageYOffset
          // ターゲットの上端～下端に走査線が入ったら処理
          if (sensorVal > triggerStart && sensorVal < triggerEnd) {
            const target = trigger.dataset.navTarget // 制御対象名を取得
            // 全てのactiveを外す
            for (let index = 0; index < items.length; index++) {
              const item = items[index]
              item.classList.remove('active')
            }
            // 対象アイテムをアクティブにする
            const targetItems = document.getElementsByClassName('js-scrollNav--' + target)
            for (let index = 0; index < targetItems.length; index++) {
              const targetItem = targetItems[index]
              targetItem.classList.add('active')
              targetItem.classList.add('pass') // アクティブとは別で通過済みのフラグをつける
            }
            break // 以降の判定は飛ばす
          }
        }
      })
      isAction = true
    }
  }
}

$(function () {
  $('.js-parent').click(function () {
    let href = $(this).attr('href')
    $(this).children('.toggle').toggleClass('open')
    $('.js-child-' + href).toggleClass('display')
    if (!$(this).hasClass('open')) {
      $('.js-child-' + href).removeClass('open')
    }
    return false
  })

  $('.js-tax').click(function () {
    $(this).toggleClass('open')
    $(this).nextAll('.js-list').toggleClass('display')
  })
})

function disableScroll(event) {
  event.preventDefault()
}

if (document.getElementById('productsSingleSlide')) {
  // Swiperコンテナを検出したら実行
  // eslint-disable-next-line no-unused-vars
  const slideItem = document.getElementById('productsSingleSlide')
  const sliderName = 'productsSingleSlide'
  const thumbClass = 'productsSingleSlide__thumblist-item flex vcenter hcenter'
  const mytap = window.ontouchstart === null ? 'touchstart' : 'click'
  const topWorkSwiper = new Swiper(slideItem, {
    effect: 'slide', // slide,fade,cube,coverflow
    speed: 1000, // アニメ速度
    loop: true, // ループ
    preloadImages: false, // スライド内の画像を読み終えてから開始
    slidesPerView: 1, //表示数変更
    spaceBetween: 0, //スライド同士の間隔を空ける

    navigation: {
      nextEl: '.swiper-button-next--' + sliderName, // 前のページボタンを呼び出す要素
      prevEl: '.swiper-button-prev--' + sliderName, // 次のページボタンを呼び出す要素
    },
    pagination: {
      el: '.thumblist',
      type: 'custom',
      renderCustom: function (swiper, current, total) {
        const slides = swiper.slides
        let html = ''
        for (let i = 1; i <= total; i++) {
          if (current === i) {
            html = html + `<div class="${thumbClass} current" data-slideto="${i}">${slides[i].innerHTML}</div>`
          } else {
            html = html + `<div class="${thumbClass}" data-slideto="${i}">${slides[i].innerHTML}</div>`
          }
        }
        return html
      },
    },
  })
  const clickThumbs = () => {
    const thumbItems = document.getElementsByClassName(thumbClass)
    for (let i = 0; i < thumbItems.length; i++) {
      thumbItems[i].addEventListener(
        mytap,
        (e) => {
          let index = e.currentTarget.dataset.slideto
          topWorkSwiper.slideTo(index, 1500, true)
        },
        false
      )
    }
  }

  clickThumbs()
  topWorkSwiper.on('slideChange', clickThumbs)
}

$('.js-info-morebtn').click(function () {
  $('.InfomationBacknumberItemWrap').toggleClass('show')
  $(this).toggleClass('open')
  return false
})

$('.js-faq-open').click(function () {
  $(this).toggleClass('open')
  $(this).next('.js-faq-answer').slideToggle()
  return false
})

$('.js-toggle-open').click(function () {
  $(this).toggleClass('open')
  $(this).next('.js-toggle-wrap').slideToggle()
  return false
})

const infiniteSlider = new Swiper('.infinite-slider', {
  loop: true,
  // loopedSlides: 2,
  slidesPerView: 'auto',
  speed: 8000,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
  },
})

const swiper = new Swiper('.swiper-relate', {
  // loop: true,
  slidesPerView: 1.1,
  centeredSlides: true,
  spaceBetween: 36,
  breakpoints: {
    600: {
      slidesPerView: 2,
    },
  },
  // ナビボタンが必要なら追加
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
})

const relateProductSlide = new Swiper('#relateProductSlide', {
  loop: true,
  slidesPerView: 2,
  spaceBetween: 15,
  breakpoints: {
    768: {
      slidesPerView: 3,
    },
  },
  // ナビボタンが必要なら追加
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
})

const topFloorSlide = new Swiper('#topFloorSlide', {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 0,
  breakpoints: {
    768: {
      slidesPerView: 1,
    },
  },
  // ナビボタンが必要なら追加
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true,
    renderBullet: function (index, className) {
      //中の文字を表示
      return (
        '<span class="' +
        className +
        ' topProduct__btn flex hcenter vcenter">' +
        ['オフィス<br class="sp">フロア', 'ショップ・<br class="sp">飲食店舗', '建築事務所', '建築現場'][index] +
        '</span>'
      )
    },
  },
})
